import { useRpQuery } from '~/composables/graphql'
import { useMutation } from '@tanstack/vue-query'
import type { SignDocumentInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'

// Update the contract with the completed document information
export function useSignDocumentMutation() {
    const query = useRpQuery()
    return useMutation({
        mutationFn: async (mutationData: {
            input: SignDocumentInput
            facilityId: string
        }) => {
            const response = await query(
                graphql(/** @lang GraphQL */ `
                    mutation CompleteDocument(
                        $input: SignDocumentInput!
                        $facilityId: ID!
                    ) {
                        signDocument(input: $input) {
                            __typename
                            ... on SignDocumentResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...AnalyticsAddToCartResultFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    path
                                    message
                                }
                            }
                        }
                    }
                `),
                mutationData
            )

            return response.signDocument
        }
    })
}
